const isCordova = () => {
    if(window.cordova)
        return true;
    else 
        return false;
}

export default isCordova;